import {
  CalendarDays,
  ChartColumnIncreasing,
  Navigation,
  Settings,
} from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
import {
  AppScreen,
  CalendarGrid,
  CalendarLegend,
  Fab,
  MonthNav,
  StatusBar,
  TabBar,
} from './kit';
import type { CalendarDay } from './kit';
import { useInView } from './useInView';
import './CalendarMotionDemo.css';

// Day 22 starts on Jose's side (cream) so the demo can show the swap approval.
const THEM_DAYS = new Set([6, 7, 20, 21, 22]);
const PENDING_DAYS = new Set([8, 22]);

const MARCH_2026: CalendarDay[] = Array.from({ length: 31 }, (_, index) => {
  const day = index + 1;
  return {
    day,
    fill: THEM_DAYS.has(day) ? 'them' : 'you',
    pending: PENDING_DAYS.has(day),
  };
});

const NEXT_MONTH: CalendarDay[] = [1, 2, 3, 4].map((day) => ({
  day,
  fill: 'none',
  fadedOut: true,
}));

const WEEKS: CalendarDay[] = [...MARCH_2026, ...NEXT_MONTH];

export function CalendarMotionDemo() {
  const { ref, seen } = useInView<HTMLDivElement>({ threshold: 0.2 });

  return (
    <PhoneFrame size='md'>
      <AppScreen size='md'>
        <div ref={ref} className={`cal-motion${seen ? ' is-seen' : ''}`}>
          <StatusBar />

          <header className='mk-header cal-header'>
            <span className='mk-header__title mk-header__title--brand'>
              Calendar
            </span>
          </header>

          <div className='cal-body'>
            <CalendarLegend />

            <MonthNav month='March 2026' />

            <CalendarGrid weeks={WEEKS} />

            <div className='cal-chips'>
              <div className='cal-chip cal-chip--schedule'>
                <CalendarDays
                  className='cal-chip__icon'
                  size={15}
                  strokeWidth={2}
                />
                <span className='cal-chip__label'>
                  Charlie · Weekdays + Alternating Weekends
                </span>
              </div>
              <button
                type='button'
                className='cal-gear'
                aria-label='Calendar settings'
              >
                <Settings size={15} strokeWidth={1.8} />
              </button>
            </div>

            <div className='cal-chips cal-chips--split'>
              <div className='cal-chip'>
                <Navigation
                  className='cal-chip__icon'
                  size={15}
                  strokeWidth={2}
                />
                <span className='cal-chip__label'>GPS Check-ins</span>
              </div>
              <div className='cal-chip'>
                <ChartColumnIncreasing
                  className='cal-chip__icon'
                  size={14}
                  strokeWidth={1.8}
                />
                <span className='cal-chip__label'>Exchange History</span>
              </div>
            </div>
          </div>

          <Fab />
          <TabBar active='calendar' />
        </div>
      </AppScreen>
    </PhoneFrame>
  );
}
